import {Button, Nav, Navbar, NavbarBrand} from "react-bootstrap";
import * as PropTypes from "prop-types";


function Link(props) {
    return null;
}

Link.propTypes = {
    href: PropTypes.string,
    children: PropTypes.node
};
export default function CustomNavbar() {

    return (
        <Navbar>
            <NavbarBrand>
                <Link href={"/"}>
                </Link>
            </NavbarBrand>

            <Nav className={"me-auto"}>
                <Link data-cy={"Movies-NavButton"} href={`/movies`} className={'text-decoration-none text-green'} style={{fontSize: "1.5rem"}}>
                    | Movies
                </Link>
            </Nav>

            <Nav className={"ms-2"}>
                    <Link href={"/enter"}>
                        <Button>Log In</Button>
                    </Link>
            </Nav>

        </Navbar>
    )
}